import { ScrapeRefundOutcome } from "@signalist/shared-types";

import { ScrapeRequest } from "@/pages/Private/pages/CustomEvent/schema/scrapeRequest";

export interface ScrapeRequestCancelToast {
	key: string;
	options?: { count: number };
}

/**
 * What the user is told after cancelling a scrape request (PREC-4456), from the API's answer:
 * what it gave back (1 credit for the scraping request that created the source, 0.5 for a
 * re-scrape), that nothing was charged, or that a charge could not be matched (never "nothing
 * was charged" then). An answer without an outcome claims nothing about credits.
 */
export const scrapeRequestCancelToast = (
	cancelled: Pick<ScrapeRequest, "isInitial" | "refundedCredits" | "refundOutcome">
): ScrapeRequestCancelToast => {
	switch (cancelled.refundOutcome) {
		case ScrapeRefundOutcome.REFUNDED:
			return {
				key: cancelled.isInitial
					? "customEvent.rescrape.toast.cancelledInitial"
					: "customEvent.rescrape.toast.cancelledRescrape",
				options: { count: cancelled.refundedCredits ?? 0 },
			};
		case ScrapeRefundOutcome.NOT_CHARGED:
			return { key: "customEvent.rescrape.toast.cancelledNothingCharged" };
		case ScrapeRefundOutcome.CHARGE_UNRESOLVED:
			return { key: "customEvent.rescrape.toast.cancelledChargeUnresolved" };
		default:
			return { key: "customEvent.rescrape.toast.cancelled" };
	}
};
